export const STATUS_COLORS = {
  default: { color: "#5f6b7a", background: "#eef1f4", border: "#cbd2d9" },
  warning: { color: "#8a6100", background: "#fff3cd", border: "#f1d27a" },
  info: { color: "#1769aa", background: "#e3f2fd", border: "#90caf9" },
  success: { color: "#14733c", background: "#e5f6ec", border: "#95d5aa" },
  paused: { color: "#8a4b08", background: "#fff0df", border: "#f5bd7e" },
  danger: { color: "#a61b29", background: "#fde8ea", border: "#ef9aa4" },
  purple: { color: "#6941c6", background: "#f1ebff", border: "#c9b6f4" },
};

const option = (value, colorKey) => ({ value, label: value, color: STATUS_COLORS[colorKey] });

export const CONTRACT_ITEM_STATUSES = [
  option("Chưa bắt đầu", "warning"),
  option("Đang thực hiện", "info"),
  option("Hoàn thành", "success"),
  option("Tạm dừng", "paused"),
  option("Hủy bỏ", "danger"),
];

export const CONTRACT_STATUSES = CONTRACT_ITEM_STATUSES;

export const APPROVAL_STATUSES = [
  option("Tạo mới", "default"),
  option("Chỉnh sửa", "purple"),
  option("Đang chỉnh sửa", "purple"),
  option("Chờ phê duyệt", "warning"),
  option("Đã phê duyệt", "success"),
  option("Được phê duyệt", "success"),
];

export const APPROVAL_STEP_STATUSES = [
  option("Đang xử lý", "info"),
  option("Chờ xử lý", "warning"),
  option("Đã phê duyệt", "success"),
  option("Yêu cầu chỉnh sửa", "purple"),
];

export const CONTRACT_ITEM_APPROVAL_STATUSES = APPROVAL_STATUSES;

export const ACCEPTANCE_STATUSES = [
  option("Chưa nghiệm thu", "default"),
  option("Không nghiệm thu", "danger"),
  option("Được nghiệm thu", "success"),
  option("Thực hiện lại", "warning"),
];

export const PRIORITIES = [
  { value: 1, label: "Cao" },
  { value: 2, label: "Trung bình" },
  { value: 3, label: "Thấp" },
];

export const DIFFICULTY_LEVELS = [1, 2, 3, 4, 5].map((value) => ({ value, label: String(value) }));

export const UNITS = ["%", "Bộ", "Cái", "Điểm", "Gói", "ha", "kg", "m", "m²", "Mảnh QĐ", "Ngày", "Phần", "Tấn", "Tháng"]
  .map((value) => ({ value, label: value }));

export const normalizeStatusValue = (value) =>
  String(value || "")
    .trim()
    .toLocaleLowerCase("vi-VN");

export const STATUS_COLOR_BY_VALUE = [
  ...CONTRACT_STATUSES,
  ...APPROVAL_STATUSES,
  ...APPROVAL_STEP_STATUSES,
  ...ACCEPTANCE_STATUSES,
].reduce((result, item) => ({ ...result, [normalizeStatusValue(item.value)]: item.color }), {});
